var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMostObservedObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 144,
    viewBox: "0 0 238 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 238,
    height: 143,
    rx: 8,
    fill: "#F3F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 86.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 86.7324,
    width: 85,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22.7324,
    width: 85,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 54.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 54.7324,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 102.732,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 102.732,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38.7324,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 70.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 70.7324,
    width: 105,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_6535_1117528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 118.732,
    width: 214,
    height: 4,
    rx: 2,
    fill: "#CDE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 118.732,
    width: 105,
    height: 4,
    rx: 2,
    fill: "#11A3E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 86.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 54.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 102.732,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 70.7324,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_6535_1117528"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 118.732,
    width: 214,
    height: 4,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostObservedObjects);
export default __webpack_public_path__ + "static/media/mostObservedObjects.b004beaf9769934f4b7e09263f25a5db.svg";
export { ForwardRef as ReactComponent };